/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import type { NextFunction, MiddlewareFunction } from './interfaces';

const callMiddleware = <Args extends any[], E = Error>(middleware: MiddlewareFunction<Args, E>, args: Args): Promise<void> => (
    new Promise((resolve, reject) => {
        const next: NextFunction<E> = (err?: E) => err ? reject(err) : resolve();

        try {
            middleware(next, ...args);
        } catch (e) {
            console.error('Unexpected error in middleware:', e);
            console.error('Middleware function:', middleware.toString());
            reject(e);
        }
    })
);

const callMiddlewaresInOrder = <Args extends any[], E>(middlewares: MiddlewareFunction<Args, E>[], args: Args, index = 0): Promise<void> => (
    callMiddleware<Args, E>(middlewares[index], args)
        .then(() => {
            if ((index + 1) < middlewares.length) {
                return callMiddlewaresInOrder<Args, E>(middlewares, args, index + 1);
            }
        })
);

const callMiddlewares = <Args extends any[], E = Error>(middlewares: MiddlewareFunction<Args, E>[], ...args: Args): Promise<void> => (
    callMiddlewaresInOrder<Args, E>(middlewares, args)
);

export {
    callMiddlewares,
};
